import request from '@/utils/httpRequest'
// 品质检查标准
export function queryById (id) {
    return request({
        url: '/quality/wuyeQualityInspectionStandard/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/quality/wuyeQualityInspectionStandard/startFlow',
        method: 'post',
        data: params
    })
}